import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M19.6 3.2H18.5V1H16.3V3.2H7.5V1H5.3V3.2H4.2C2.99 3.2 2 4.19 2 5.4V20.8C2 22.01 2.99 23 4.2 23H19.6C20.81 23 21.8 22.01 21.8 20.8V5.4C21.8 4.19 20.81 3.2 19.6 3.2ZM19.6 20.8H4.2V9.8H19.6V20.8ZM4.2 7.6V5.4H19.6V7.6H4.2ZM7.753 17.951L8.919 19.117L11.603 16.433L14.287 19.117L15.453 17.951L12.769 15.267L15.453 12.583L14.287 11.417L11.603 14.101L8.919 11.417L7.753 12.583L10.437 15.267L7.753 17.951Z" fill="black"/>
</svg>
;
